import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, Col, Row } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';
import PageHeader from 'components/ui/PageHeader';
import useExport from 'hook/useExport';
import { requestCardiovascularReports } from 'services/api/request/exports';
import { ReactComponent as IconFile } from 'svg/file-solid.svg';
import s from './styles.module.scss';

const ReportManagementPanel = ({ patientId, patientName, t }) => {
  const [setLoadingExport] = useExport(requestCardiovascularReports, patientId);

  return (
    <Row>
      <Col xs={4}>
        <Button
          component={Link}
          to={`/patient/${patientId}/cardiovascular-reports/upload`}
          variant="secondary"
        >
          {t('reports.uploadNewReport')}
        </Button>
      </Col>
      <Col xs={4} className={s.subPageHeader}>
        <PageHeader title="" patientInfo={[`${patientName}`, `RPM-CIED-${patientId}`]} />
      </Col>
      <Col xs={4}>
        <Button
          icon={<IconFile />}
          onClick={() => setLoadingExport(true)}
          outlined
          variant="primary"
          className={s.pullRight}
        >
          {t('reports.exportReports')}
        </Button>
      </Col>
    </Row>
  );
};

ReportManagementPanel.propTypes = {
  patientId: PropTypes.string.isRequired,
  patientName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ReportManagementPanel);
